import AddNumberToBlacklist from './AddNumberToBlacklist';
import BlacklistListItem from './BlacklistListItem';

// @vue/component
export default {
  name: 'BlacklistList',

  components: {
    AddNumberToBlacklist,
    BlacklistListItem,
  },

  computed: {
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'blacklist/getList',
        'blacklist/create',
        'blacklist/delete',
      ]);
    },
    blacklistList() {
      return this.$store.getters['blacklist/list'];
    },
  },

  created() {
    this.$store.dispatch('blacklist/getList');
  },
};
